import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import InputFactory from "../InputFactory";
import InterviewTable from "./components/InterviewTable";
import InterviewTally from "./components/InterviewTally";
import InterviewImpression from "./components/InterviewImpression";
import { dialog, Progress } from "../../nq-component";
import DialogSuccess from "../../pages/interview-form/components/Dialog/DialogSuccess";
import DialogWarning from "../../pages/interview-form/components/Dialog/DialogWarning";
import { saveFileUseCase, saveImageUseCase } from "../../usecases/file";

const InterviewForm = ({
  object,
  formData = {},
  onCancel,
  onSave,
  isRecruiter,
  progress,
}) => {
  console.log(object);
  const [formState, setFormState] = useState({
    appearanceRating: "",
    bearingRating: "",
    expressionRating: "",
    jobKnowledgeRating: "",
    motivationRating: "",
    personalityRating: "",
    comments: "",
    recommendation: "",
    file: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(progress);
  }, [progress]);

  useEffect(() => {
    if (object?.interviewForm) {
      setFormState({
        appearanceRating: object.interviewForm.appearanceRating || "",
        bearingRating: object.interviewForm.bearingRating || "",
        expressionRating: object.interviewForm.expressionRating || "",
        jobKnowledgeRating: object.interviewForm.jobKnowledgeRating || "",
        motivationRating: object.interviewForm.motivationRating || "",
        personalityRating: object.interviewForm.personalityRating || "",
        comments: object.interviewForm.comments || "",
        recommendation: object.interviewForm.recommendation || "",
        file: object.interviewForm.file || "",
      });
    }
  }, [object?.interviewForm]);
  console.log(formState);
  const categories = [
    { key: "appearanceRating", label: "Appearance" },
    { key: "bearingRating", label: "Bearing" },
    { key: "expressionRating", label: "Expression" },
    { key: "jobKnowledgeRating", label: "Job Knowledge" },
    { key: "motivationRating", label: "Motivation" },
    { key: "personalityRating", label: "Personality" },
  ];

  const descriptions = [
    {
      value: "1",
      text: [
        "Indifferent to attire and grooming, sloppy, Unkept",
        "No bearing, Lacks confidence, slovenly Posture",
        "Uncommunicative, confused thoughts, poor vocabulary",
        "None as pertains to this position",
        "None, Apathetic, Indifferent, Disinterested",
        "Unpleasant",
      ],
    },
    {
      value: "2",
      text: [
        "Careless attire, poor grooming",
        "Often appears uncertain, poor posture",
        "Poor speaker, hazy thoughts and ideas",
        "Will need considerable training",
        "Doubtful interest in position",
        "Slightly objectionable",
      ],
    },
    {
      value: "3",
      text: [
        "Functional attire, Neatly groomed",
        "Holds self well, seems confident",
        "Speaks well, expresses ideas adequately",
        "Basic, but will learn on",
        "Sincere desire to work",
        "Likeable",
      ],
    },
    {
      value: "4",
      text: [
        "Well groomed",
        "Sure of self, reflects confidence",
        "Speaks, thinks clearly with confidence",
        "Well versed in position, little training needed",
        "Strong interest in position, ask questions",
        "Pleasing",
      ],
    },
    {
      value: "5",
      text: [
        "Immaculate attire & grooming",
        "Highly confident, inspires others, asserts presence",
        "Exceptional, speaks clearly, concisely with confidence, ideas well thought out",
        "Extremely well versed, able to work without further training",
        "Highly motivated, Eager to work, Ask many questions",
        "Extremely pleasing, Charming individual",
      ],
    },
  ];

  const ratingCategories = [
    { label: "Unsatisfactory", range: [1, 15] },
    { label: "Marginal", range: [16, 18] },
    { label: "Satisfactory", range: [19, 21] },
    { label: "Very Good", range: [22, 25] },
    { label: "Excellent", range: [26, 30] },
  ];

  const handleCheckboxChange = (category, value) => {
    setFormState({
      ...formState,
      [category]: value,
    });
  };

  const handleInputChange = (field, value) => {
    setFormState({
      ...formState,
      [field]: value,
    });
  };

  const calculateTotalPoints = () => {
    const {
      appearanceRating,
      bearingRating,
      expressionRating,
      jobKnowledgeRating,
      motivationRating,
      personalityRating,
    } = formState;

    return (
      Number(appearanceRating) +
      Number(bearingRating) +
      Number(expressionRating) +
      Number(jobKnowledgeRating) +
      Number(motivationRating) +
      Number(personalityRating)
    );
  };

  const getRatingCategoryForPoints = (points) => {
    if (points === 0) return null;

    return ratingCategories.find(
      (category) => points >= category.range[0] && points <= category.range[1]
    );
  };

  const handleFileUpload = (value) => {
    setFormState({
      ...formState,
      file: value,
    });
  };

  const handleSubmit = () => {
    const totalPoints = calculateTotalPoints();
    onSave(formState, object, totalPoints);
  };

  const totalPoints = calculateTotalPoints();

  const currentRatingCategory = getRatingCategoryForPoints(totalPoints);

  return (
    <div className="bg-white p-3 rounded mt-1">
      <h6 className="mt-2 fs-5">
        Current Position:{" "}
        <span className="fw-bold">{object?.positionApplied}</span>
      </h6>

      <div
        className="mt-4 border pb-3"
        style={{
          borderRadius: "12px 12px 12px 12px",
        }}
      >
        <div style={{ overflowX: `auto` }}>
          <InterviewTable
            isRecruiter={isRecruiter}
            object={object?.interviewForm}
            categories={categories}
            descriptions={descriptions}
            formState={formState}
            handleCheckboxChange={handleCheckboxChange}
          />
        </div>

        <InterviewTally
          calculatePoints={calculateTotalPoints()}
          categories={categories}
          formState={formState}
        />
        <div className="p-4" style={{ width: "97%" }}>
          <InterviewImpression
            ratingCategories={ratingCategories}
            currentRatingCategory={currentRatingCategory}
          />

          <div className="row mt-4">
            <div className="col-md-6">
              <label className="fw-normal">Comments</label>
              <textarea
                disabled={!isRecruiter}
                className="form-control mt-2 p-3"
                placeholder="Enter comments"
                value={formState.comments}
                onChange={(e) => handleInputChange("comments", e.target.value)}
                style={{
                  width: "100%",
                  height: "100px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "10px",
                  border: "1px solid #ddd",
                }}
              ></textarea>
            </div>
            <div className="col-md-6">
              <label className="fw-normal">Recommendation</label>
              <textarea
                disabled={!isRecruiter}
                className="form-control mt-2 p-3"
                placeholder="Enter recommendation"
                value={formState.recommendation}
                onChange={(e) =>
                  handleInputChange("recommendation", e.target.value)
                }
                style={{
                  width: "100%",
                  height: "100px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "10px",
                  border: "1px solid #ddd",
                }}
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-5 p-3">
        <div>
          <h6 className="fw-bold">Capture Image</h6>
          <hr />
          {isRecruiter && (
            <>
              <label className="fw-bold">
                Attach Image
                <span className="text-danger ms-1 fw-lighter">*</span>
              </label>
              <InputFactory
                type="InputCamera"
                saveImage={saveImageUseCase()}
                saveFile={saveFileUseCase()}
                onChange={handleFileUpload}
                field="file"
              />
            </>
          )}
        </div>
        {formState.file && (
          <div className="mt-3">
            <label className="fw-bold">Attached File:</label>
            <ul className="list-group mt-2">
              <div className="border-1 border rounded-3 position-relative col-lg-4 col-sm-6">
                <img className="w-100" src={`${formState.file}`}></img>
                <button
                  disabled={formState.file !== ""}
                  className="btn btn-sm bg-white position-absolute"
                  onClick={() => setFormState({ ...formState, file: "" })}
                  style={{ top: `2%`, right: `2%` }}
                >
                  <i className="bi bi-trash text-danger"></i>
                </button>
              </div>
            </ul>
          </div>
        )}
        {isRecruiter && (
          <div className="d-flex mt-4">
            <button
              className="btn"
              style={{
                backgroundColor: "#D3D3D3",
                width: "130px",
                height: "45px",
                fontWeight: "500",
              }}
              onClick={onCancel}
              disabled={loading}
            >
              {object?.interviewForm ? "Back" : "Cancel"}
            </button>
            <button
              className="btn text-white ms-2"
              // disabled={object?.interviewForm}
              style={{
                backgroundColor: "#E09552",
                minWidth: "130px",
                height: "45px",
                fontWeight: "500",
              }}
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? (
                <div className="d-flex gap-2">
                  <Progress />
                  <p className="m-0">Submitting...</p>
                </div>
              ) : (
                "Save"
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

InterviewForm.propTypes = {
  initialData: PropTypes.object,
  positionOptions: PropTypes.array,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  showNavBar: PropTypes.bool,
  schema: PropTypes.object,
  currentUser: PropTypes.object,
  getSchema: PropTypes.func,
  getCurrentUser: PropTypes.func,
};

export default InterviewForm;
